import { ChangeDetectorRef, Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  CartKeyService,
  CartService,
  CheckoutConfigService,
  CheckoutObject,
  CheckoutWrapperComponent,
  GungModalService,
  OrderSubmitService
} from 'gung-standard';

@Component({
    selector: 'colmec-checkout-wrapper',
    templateUrl: './colmec-checkout-wrapper.component.html',
    styleUrls: ['./colmec-checkout-wrapper.component.scss'],
    standalone: false
})
export class ColmecCheckoutWrapperComponent extends CheckoutWrapperComponent {
 

  quotationCheckoutObject() {
    this.currentCheckout = {
      ...this.currentCheckout,
      extra: {
        ...this.currentCheckout.extra,
        oh: {
          ...this.currentCheckout.extra.oh,
          ordstat: 0
        }
      }
    };
    this.submitOrder();
  }
}
